module.exports = __webpack_public_path__ + "static/img/4.ecaa8d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/sp/4.png
// module id = 8fDt
// module chunks = 0